var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33968",
    "data-name": "Group 33968",
    transform: "translate(18586 21844)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9771",
    "data-name": "Rectangle 9771",
    width: 24,
    height: 24,
    transform: "translate(-18586 -21844)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_60_215",
    "data-name": "Component 60 \\u2013 215",
    transform: "translate(-18582.105 -21842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9770",
    "data-name": "Rectangle 9770",
    width: 1.351,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70474",
    "data-name": "Path 70474",
    d: "M15.671,4.458v6.08H9.591a.676.676,0,0,1-.675-.675V9.186h2.027V4.458Z",
    transform: "translate(-0.811 -0.405)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70475",
    "data-name": "Path 70475",
    d: "M10.268,2.7V2.026A2.027,2.027,0,0,0,8.241,0H1.486V1.351H8.241a.675.675,0,0,1,.675.675v5.4H1.486V8.782h5.4v.675a2.026,2.026,0,0,0,2.026,2.026h7.431V2.7ZM15,10.133H8.916a.676.676,0,0,1-.675-.675V8.782h2.027V4.053H15Z",
    transform: "translate(-0.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70476",
    "data-name": "Path 70476",
    d: "M8.917,2.161v5.4H1.486V1.486H8.241a.676.676,0,0,1,.675.675",
    transform: "translate(-0.135 -0.135)",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b87dce7f115338e514f935ad967ac763.svg";
export { ForwardRef as ReactComponent };